/* global site_params */
import $ from 'jquery';
import {startTimer} from './helpers';

const win = typeof window !== 'undefined' ? window : this;
const doc = win.document;

class Core {
    constructor(config) {
        this.config = config;

        this.version = '@version';
        this.components = {};

        this.resizeHandlers = [];
        this.scrollHandlers = [];
        this.RAFHandlers = [];

        // Globals
        this.window = win;
        this.$window = $(win);
        this.document = doc;
        this.$document = $(doc);
        this.$body = null;

        // Flags
        this.viewportWidth = 0;
        this.viewportHeight = 0;
        this.viewportInitialHeight = 0;
        this.userAgent =
            window.navigator.userAgent ||
            window.navigator.vendor ||
            window.opera;
        this.isFirefox = /Firefox/i.test(this.userAgent);
        this.isChrome = /Chrome/i.test(this.userAgent);
        this.isSafari = /Safari/i.test(this.userAgent) && !this.isChrome;
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            this.userAgent
        );
        this.isIEMobile = /IEMobile/i.test(this.userAgent);
        this.isBadHexRegex = '/^[-+]0x[0-9a-f]+$/i';
        this.isFirefoxMobile = this.isFirefox && this.isMobile;
        this.transform = null;
        this.transition = null;
        this.ResizeTimer = null;
        this.Debounce = 20;

        this.support = {
            file: !!(
                window.File &&
                window.FileList &&
                window.FileReader
            ),
            history: !!(
                window.history &&
                window.history.pushinstance &&
                window.history.replaceinstance
            ),
            matchMedia: !!(window.matchMedia || window.msMatchMedia),
            pointer: !!window.PointerEvent,
            raf: !!(
                window.requestAnimationFrame && window.cancelAnimationFrame
            ),
            touch: !!(
                'ontouchstart' in window ||
                (window.DocumentTouch &&
                    document instanceof window.DocumentTouch)
            ),
            transition: false,
            transform: false,
        };
    }
}

const core = new Core(site_params);
const $Ready = $.Deferred();
const Debounce = 20;

let ResizeTimer = null;

Core.prototype.Ready = (fn) => {
    if (
        core.document.readyState === "complete" ||
        (core.document.readyState !== "loading" && !core.document.documentElement.doScroll)
    ) {
        fn();
    } else {
        core.document.addEventListener("DOMContentLoaded", fn);
    }
};

Core.prototype.Component = function (namespace, settings) {
    core.components[namespace] = (function (namespace, settings) {

        // Locals

        settings.initialized = false;
        settings.priority = settings.priority || 10;

        // Extend Methods

        settings.methods = $.extend(true, {

            // Private Methods

            _construct: $.noop, // Constructor
            _resize: false, // Window resize

        }, settings.methods);

        // Register Plugin

        // Run Setup

        settings.namespace = namespace;

        settings.methods._construct.apply(this, arguments);

        // Resize handler

        if (settings.methods._resize) {
            core.resizeHandlers.push({
                namespace: namespace,
                priority: settings.priority,
                callback: settings.methods._resize
            });

            // Sort handlers on push
            core.resizeHandlers.sort(sortPriority);
        }

        // RAF handler

        if (settings.methods._raf) {
            core.RAFHandlers.push({
                namespace: namespace,
                priority: settings.priority,
                callback: settings.methods._raf
            });

            // Sort handlers on push
            core.RAFHandlers.sort(sortPriority);
        }

        return settings;
    })(namespace, settings);

    return core.components[namespace];
};

// Window resize

function handleWindowResize() {
    for (let i in core.resizeHandlers) {
        if (core.resizeHandlers.hasOwnProperty(i)) {
            core.resizeHandlers[i].callback.call(window, core.windowWidth, core.windowHeight);
        }
    }
}

function onWindowResize() {
    core.windowWidth = core.$window.width();
    core.windowHeight = core.$window.height();

    ResizeTimer = startTimer(ResizeTimer, Debounce, handleWindowResize);
}

core.$window.on('resize', onWindowResize);
onWindowResize();

// RAF

function handleRAF() {
    if (core.support.raf) {
        core.window.requestAnimationFrame(handleRAF);

        for (let i in core.RAFHandlers) {
            if (core.RAFHandlers.hasOwnProperty(i)) {
                core.RAFHandlers[i].callback.call(window);
            }
        }
    }
}

handleRAF();

// Sort Priority

function sortPriority(a, b) {
    return (parseInt(a.priority) - parseInt(b.priority));
}

// Document Ready

core.Ready(() => {
    core.$body = $('body');

    $Ready.resolve();
});

export default core;
